import { Badge, Box, ChakraProps, IconButton } from "@chakra-ui/react"
import { Link } from "gatsby-plugin-intl"
import { observer } from "mobx-react-lite"
import React from "react"
import ChatIcon from "../../icons/Chat"
import MessageStore from "../../store/MessageStore"

export const MessageIconWithBadge = observer(({ alt }) => {
  return (
    <Box pos="relative">
      <ChatIcon alt={alt} fontSize="1em" />
      <Badge
        borderRadius="base"
        bg="danger.base"
        color="white"
        fontWeight="500"
        size="sm"
        fontSize="300"
        d={MessageStore.unread > 0 ? "block" : "none"}
        pos="absolute"
        right="-0.3em"
        top="-0.3em"
        transform="translate(50%,-50%)"
      >
        {MessageStore.unread > 99 ? 99 : MessageStore.unread}
      </Badge>
    </Box>
  )
})

export const Messages = observer((props: ChakraProps) => {
  return (
    <Link to="/messages/">
      <IconButton
        {...props}
        variant="outline"
        size="sm"
        as="span"
        outline="none"
        bg="white"
        borderWidth="1px"
        borderColor="tealBlue.base"
        color="tealBlue.base"
        aria-label="Messages"
        icon={<MessageIconWithBadge alt="Messages" />}
      ></IconButton>
    </Link>
  )
})
